import React from 'react'
//import LiveUpdateFirebase from '../components/LiveUpdateFirebase'

import Header2 from "../components/NavbarInner";
import Footer from "../components/Footer";

//go to top if any any new page render
import GoToTop from '../components/GoToTop'; 


export default function TermsConditions() {
  return (
    <>
<Header2 /> 

<div className='subPage'> 
<div className='container'>

<div className='row'>

<div className='col-12'>

<h3>TERMS & CONDITIONS </h3>
<p>Please read the following terms and conditions (the "terms and conditions") carefully before using this site.</p>

</div>


<div className='col-12'>

<h4 className='mt-3'>Introduction </h4>
<p>Terms and Conditions (the "terms and conditions") apply to the use of the site. By using this site, you signify that you unconditionally agree and accept to be legally bound by the Terms and Conditions. If you do not agree with any part of the Terms and Conditions, you must not use this site. If you are accessing our site or initiating transactions on our site, you will be deemed to have read, understood and agreed to these Terms and Conditions & the Privacy Policy.
</p>


<h4 className='mt-5'>Use of Site </h4>
<p>We permit you a limited, non-exclusive, non-transferable, non-sub-licensable and revocable right to use this
                  site in accordance with the Terms and Conditions. You agree that you:
</p>


<ul>
                  <li>
                    Shall only use this site to make authentic reservations or purchases and shall not use this site for any other purposes,
                    including without limitation, to make any speculative, false or fraudulent reservation or any reservation
                    in anticipation of demand.
                  </li>
                  <li>
                    Shall not employ deceptive email addresses or fabricate information in the header, footer, return path, or any part of any
                    communication, including emails, transmitted through this site.
                  </li>
                  <li>
                    Shall not, except as permitted under applicable UAE law, copy, reproduce, republish, upload, post, transmit, distribute or
                    otherwise communicate or display to the public any of the content provided in this site, including the
                    text, graphics, button icons, audio and video clips, digital downloads, data compilations and software,
                    without the prior written permission of visitdubai.co.in (except that you may download, display and print
                    the materials presented on this site for your personal, non-commercial use only).
                  </li>
                  <li>
                    Shall not, except as permitted under applicable UAE law, alter, modify, translate, decompile, adapt, disassemble, reverse
                    engineer or create derivative works from any content or component from this site.
                  </li>
                  <li>
                    Shall not transmit or otherwise transfer any web pages, data or content found on this site to any other computer, server,
                    website, or other medium for mass distribution or for use in any commercial enterprise. The use of such
                    materials on any other website or in any environment of networked computers is prohibited.
                  </li>
                  <li>
                    Shall not use any device, software or routine to interfere or attempt to interfere with the proper working of this site.
                  </li>
                  <li>
                    Shall not make any unlicensed use of this site and/or the materials contained on this site to violate applicable copyright,
                    trademark or other intellectual property laws or other laws. You must retain all copyright and trademark
                    notices, including any other proprietary notices, contained in the materials, and you must not alter,
                    obscure or obliterate any of such notices.
                  </li>
                  <li>
                    Shall not post or transmit any unlawful, threatening, vilifying, defamatory, obscene, indecent, inflammatory, pornographic
                    or profane material or any material that could constitute or encourage conduct that would be considered
                    a criminal offense, give rise to civil liability, or otherwise violate any law or applicable regulation
                    or code of conduct.
                  </li>
                  <li>
                    Shall not post or broadcast any information which (i) infringes the rights of others or violates their privacy or publicity
                    rights, (ii) is protected by copyright, trademark or other proprietary right, unless with the express
                    written permission of the owner of such right, (iii) contains a virus, bug, worm, time bomb, Trojan horse,
                    trap door or other harmful item, (iv) is used to unlawfully conspire against another person in restraint
                    of trade or competition.
                  </li>
                  <li>
                    You agree that you shall be uniquely liable for any damages resulting from any infringement of copyright, trademark, or other
                    proprietary right, or any other loss or harm resulting from your use of this site.
                  </li>
</ul>


<h4 className='mt-5'>Disclaimer</h4>


<p>As per UAE permitted law and subject to the statutory warranties below, the operator and visitdubai.co.in make no warranty or representation of any kind regarding this site, products or services on this site and/or any materials provided on this site, all of which are provided on an "as is" basis only. The operator and visitdubai.co.in do not warrant the accuracy, completeness, currency or reliability of any of the content or data found on this site and, subject to the statutory warranties below, expressly disclaim all warranties, terms and conditions, including all implied warranties, terms and conditions of merchantability, satisfactory quality, fitness for a general or particular purpose and non-infringement of proprietary rights, and those arising by statute or otherwise in law or from a course of dealing or usage of trade to the fullest extent permitted by the laws of the territories.

The operator and visitdubai.co.in do not warrant that this site, its servers or any e-mail sent from the operator or visitdubai.co.in are free of viruses or other harmful components. Some territories do not allow the disclaimer of implied warranties, so to that extent the foregoing disclaimer may not apply to you. In particular, in territories where it is prohibited, this disclaimer shall not in any way exclude or limit liability for personal injury or death arising from negligence, willful misconduct or fraud. This warranty gives you specific rights which vary from territory to territory.

Statutory warranties: Certain legislation may imply warranties or conditions or impose obligations which cannot be excluded, restricted or modified except to a limited extent. These terms and conditions must be read subject to any such statutory provisions. If such statutory provisions apply, to the extent to which the operator and visitdubai.co.in is entitled to do so, the liability of each will be limited at their option to:

In the case of supply of goods, the replacement of the goods or supply of equivalent goods, the payment of the c</p>



</div>



</div>



</div>
</div>


<Footer />    

<GoToTop /> 
</>

  )
}
